import FlagIcon from "@mui/icons-material/Flag";
import Box from "@mui/material/Box";
import React, {useState} from "react";
import {
    getIconForLanguage,
    getLocalizedLangLabel,
} from "crqlar-react-common/dist/utils/translations.util";
import {ElementChip} from "./base/ElementChip";

interface Props {
    languageCode: string | undefined;
    locale: string;
}

export function LanguageElement({languageCode, locale}: Props) {
    const [hasIconError, setHasIconError] = useState(false);
    const normalizedLanguageCode = languageCode?.trim();

    if (!normalizedLanguageCode) return null;

    const label = getLocalizedLangLabel(normalizedLanguageCode, locale);
    const iconUrl = getIconForLanguage(normalizedLanguageCode);
    const startIcon = iconUrl && !hasIconError
        ? (
            <Box
                component="img"
                src={iconUrl}
                alt=""
                aria-hidden="true"
                onError={() => setHasIconError(true)}
                sx={{
                    display: "block",
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    objectFit: "cover",
                }}
            />
        )
        : <FlagIcon sx={{fontSize: 16, color: "text.secondary"}}/>;

    return <ElementChip text={label || normalizedLanguageCode} startIcon={startIcon}/>;
}
